var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"short-chart"},[(_vm.balanceStatistic)?_c('short-line-chart',{style:(_vm.chartStyle),attrs:{"chart-data":_vm.chartData,"suggested-max":_vm.suggestedMax,"suggested-min":_vm.suggestedMin}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }